import { Link } from 'react-router-dom';
import { getTrendingArticles } from '@/mocks/articles';

export default function HotTopics() {
  const trendingArticles = getTrendingArticles().slice(0, 4);

  return (
    <section className="w-full py-16 md:py-20 bg-secondary-100/50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-fire-line"></i>
            热榜追踪
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门吃瓜大赛追踪
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网最热吃瓜事件实时追踪，不错过任何一个大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {trendingArticles.map((article, index) => (
            <article key={article.id} className="group">
              <Link
                to={`/article/${article.id}`}
                className="flex gap-4 bg-background-50 rounded-xl p-4 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.imageAlt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </div>

                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-[10px] font-bold text-primary-600 bg-primary-50 px-1.5 py-0.5 rounded">
                        热搜 #{index + 1}
                      </span>
                      <span className="text-[10px] text-foreground-500">{article.category}</span>
                    </div>
                    <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                  </div>

                  <div className="flex items-center gap-4 text-xs text-foreground-400 mt-2">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {article.comments.toLocaleString()} 评论
                    </span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/meiri-dasai"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-fire-line"></i>
            查看更多热门大赛
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}